<template>
  <div :class="{ 'Masterclass-Line': true, Desktop: $mq === 'desktop' }" v-if="badges.length > 0">
    <div class="Masterclass-Title">{{ masterclass.title }}</div>

    <div class="Masterclass-Badges-Container">
      <div v-for="badgeId in badges" :key="badgeId" class="Badge-Container">
        <div :class="{ Badge: true, 'Badge-Complete': acquiredBadges.includes(badgeId) }">
          <img v-if="badgeImage(badgeId)" :src="badgeImage(badgeId)" :alt="badgeTitle(badgeId)" />
        </div>
        <div class="Badge-Title">
          {{ badgeTitle(badgeId) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get'

import badgeMixin from '@/mixins/badge'

export default {
  name: 'MasterclassBadges',
  mixins: [badgeMixin],
  props: {
    masterclassId: {
      type: String,
      required: true
    }
  },
  computed: {
    masterclass() {
      return this.$store.state.lesson.theme.byId[this.masterclassId]
    },
    lessonSteps() {
      return this.masterclass.lessonSteps.map(id => this.$store.state.lesson.lessonStep.byId[id])
    },
    badges() {
      const badges = []

      // Retrieve the lesson-step badges
      this.lessonSteps.forEach(lessonStep => {
        if (!lessonStep.badgeId) return

        badges.push(lessonStep.badgeId)
      })

      // Add the masterclass badge if it exists
      if (this.masterclass.badgeId) {
        badges.push(this.masterclass.badgeId)
      }

      return badges
    }
  },
  methods: {
    badgeTitle(badgeId) {
      const badge = this.getBadge(badgeId)

      return get(badge, ['title'], null)
    },
    badgeImage(badgeId) {
      const badge = this.getBadge(badgeId)

      return get(badge, ['image'], null)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.Masterclass-Line {
  margin-bottom: 15px;

  .Masterclass-Title {
    font-weight: bold;
    font-size: 12px;
  }

  .Masterclass-Badges-Container {
    margin-top: 8px;
    display: flex;
    flex: 1 1 auto;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;

    .Badge-Container {
      text-align: center;
      vertical-align: top;
      width: 20%;
      height: 100%;

      .Badge {
        display: inline-block;
        height: 30px;
        width: 30px;
        background-color: $primary;
        opacity: 0.3;
        border-radius: 15px;

        img {
          height: 100%;
          width: 100%;
          filter: grayscale(75%);
        }

        &.Badge-Complete {
          opacity: 1;

          img {
            filter: none;
          }
        }
      }

      .Badge-Title {
        font-size: 10px;
        margin-top: 5px;
      }
    }
  }

  &.Desktop {
    .Masterclass-Title {
      font-size: 16px;
    }

    .Badge-Title {
      font-size: 12px !important;
    }

    .Badge {
      height: 50px !important;
      width: 50px !important;
      border-radius: 25px !important;
    }
  }
}
</style>
